// Тонкий i18n по контракту extension/src/i18n/i18n.ts: плоские ключи, t(key, params),
// интерполяция {param}, фолбэк на en. Отличия Mini App: язык из Telegram
// initDataUnsafe.user.language_code → navigator.language, хранение в localStorage.
import en from './locales/en.json';
import ru from './locales/ru.json';
import es from './locales/es.json';
import es419 from './locales/es419.json';
import pt from './locales/pt.json';
import de from './locales/de.json';
import fr from './locales/fr.json';
import it from './locales/it.json';
import pl from './locales/pl.json';
import uk from './locales/uk.json';
import ar from './locales/ar.json';
import { tgLanguage } from './tg';

const DICTS: Record<string, Record<string, string>> = { en, ru, es, es419, pt, de, fr, it, pl, uk, ar };
/** Языки с письмом справа налево — выставляем dir=rtl на документе. */
const RTL = new Set(['ar']);
const LS_KEY = 'cc_lang';

let lang = 'en';

function normalize(code: string | null | undefined): string {
  const two = String(code || '').toLowerCase().slice(0, 2);
  return DICTS[two] ? two : '';
}

function detect(): string {
  return normalize(tgLanguage()) || normalize(navigator.language) || 'en';
}

/** Проставить lang + dir на <html> (RTL для арабского). */
function applyDocumentDir(): void {
  if (typeof document === 'undefined') return;
  document.documentElement.lang = lang;
  document.documentElement.dir = RTL.has(lang) ? 'rtl' : 'ltr';
}

export function initLang(): string {
  let stored = '';
  try {
    stored = localStorage.getItem(LS_KEY) || '';
  } catch {
    stored = '';
  }
  lang = DICTS[stored] ? stored : detect();
  applyDocumentDir();
  return lang;
}

export function setLang(next: string): void {
  if (!DICTS[next]) return;
  lang = next;
  try {
    localStorage.setItem(LS_KEY, next);
  } catch {
    /* storage may be blocked in webview */
  }
  applyDocumentDir();
}

export function currentLang(): string {
  return lang;
}

/** Перевод с фолбэком lang→en→ключ; интерполяция {param}. */
export function t(key: string, params?: Record<string, string | number>): string {
  const raw = DICTS[lang]?.[key] ?? DICTS.en![key] ?? key;
  if (!params) return raw;
  return raw.replace(/\{(\w+)\}/g, (_, name: string) => (params[name] != null ? String(params[name]) : `{${name}}`));
}
